import React from 'react';

import { Alert, Typography, Stack } from '@gogame/components';
import { withFormField } from '@gogame/form';

import { loadGeneratedLookalikes } from 'scenes/CustomAudiences/LookalikeAudiences/sources/fields';

const ResultFormField = ({ error, area }) => {
  let data = area.data || [];

  if (!area.active) {
    return null;
  }

  if (error) {
    return <Alert severity={'error'}>{error}</Alert>;
  }

  return (
    <Alert>
      <Stack spacing={2}>
        <Typography sx={{ fontWeight: 500 }}>
          New audiences will be created:
        </Typography>

        {data.map((lookalike, i) => (
          <Typography key={lookalike.id}>{`${i + 1}. ${
            lookalike.name
          }`}</Typography>
        ))}
      </Stack>
    </Alert>
  );
};

export default withFormField({
  source: loadGeneratedLookalikes,
  normalizeValue: (_value, options) => options,
})(ResultFormField);
